import React from 'react'
import PropTypes from 'prop-types'
import { Text } from '@adc/ui-adc'
import { get } from 'lodash'
import { getLocation } from '../../util/seoContent'
import FaqContent from './faq'
const elmId = 'seo_content'

const SeoContent = ({ filters, assets }) => {
  const { list } = assets
  const state = get(filters, 'state[0]') || ''
  if (!list || list.length <= 0) return null
  if (!state || state.length <= 0) return null

  const location = getLocation(filters)
  return (
    <div className='u-pl-3 u-pr-3 u-mt-3 u-mb-4'>
      <Text color='gray' size='big' data-elm-id={`${elmId}_header`} as='h2'>
        Find the best Foreclosure and Bank-Owned property auctions in {location}
      </Text>
      <Text color='gray' size='tiny' as='p'>
        Use Auction.com - the leading online real estate marketplace for
        foreclosure and bank owned properties. Whether you’re a buyer looking
        for an affordable home in {location} or an investor looking for a
        distressed property, you can easily find great real estate investment
        opportunities with profit potential in just a few clicks. Use our
        filters to find great deals so you can participate in your next real
        estate auction.
      </Text>
      <Text color='gray' size='big' as='h2'>
        Selling Your House in {location}
      </Text>
      <Text color='gray' size='tiny' as='p'>
        Auction.com can help people interested in selling their house or
        property, if you would like to{' '}
        <a href='/lp/sell-your-property/'>sell your house</a> via auction.com go
        to our <a href='/lp/sell-your-property/'>sell my house page</a>.
      </Text>
      <Text color='gray' size='big' as='h2'>
        What’s the Best Way to Find Foreclosures Near Me?
      </Text>
      <Text color='gray' size='tiny' as='p'>
        Auction.com has the largest non mls-database of residential bank-owned
        and foreclosure homes in the US. We offer free email updates on property
        status. We specialize in online auctions and offer{' '}
        <a href='/lp/remote-bid/'>remote bid</a> so you can bid from anywhere.
        Finding foreclosures near you is easy
      </Text>
      <FaqContent filters={filters} assets={assets} />
    </div>
  )
}

SeoContent.propTypes = {
  filters: PropTypes.object.isRequired,
  assets: PropTypes.object.isRequired,
}

export default SeoContent
